export default () => ({
    toasts: [],
    duration: 5000,
    
    addToast({message, description, icon}) {
      const uuid = Math.random().toString(36).substr(2, 9);
      const timeoutId = setTimeout(() => {
        this.removeToastByUuid(uuid);
      }, this.duration);
  
      this.toasts.push({
        uuid,
        message,
        description,
        icon: icon,
        show: true,
        timeoutId
      });
    },
  
    removeToastByUuid(uuid) {
      const index = this.toasts.findIndex(t => t.uuid === uuid);
      if (index === -1) return;
      this.removeToast(index);
    },
  
    removeToast(index) {
      clearTimeout(this.toasts[index].timeoutId);
      this.toasts[index].show = false;
    },
  
    pauseToast(index) {
      if(!this.toasts[index]) return;
      clearTimeout(this.toasts[index].timeoutId);
    },
  
    resumeToast(index) {
      if(!this.toasts[index]) return;
      const uuid = this.toasts[index].uuid;
      this.toasts[index].timeoutId = setTimeout(() => {
        this.removeToastByUuid(uuid);
      }, this.duration);
    }
  });
  